/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RevokeIdentityProviderConnectionRequestBody,
  RevokeIdentityProviderConnectionRequestBody$Outbound,
  RevokeIdentityProviderConnectionRequestBody$outboundSchema,
} from "../components/revokeidentityproviderconnectionrequestbody.js";

export type RevokeIdentityProviderConnectionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RevokeIdentityProviderConnectionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  revokeIdentityProviderConnectionRequestBody:
    RevokeIdentityProviderConnectionRequestBody;
};

/** @internal */
export type RevokeIdentityProviderConnectionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RevokeIdentityProviderConnectionSecurity$outboundSchema:
  z.ZodMiniType<
    RevokeIdentityProviderConnectionSecurity$Outbound,
    RevokeIdentityProviderConnectionSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function revokeIdentityProviderConnectionSecurityToJSON(
  revokeIdentityProviderConnectionSecurity:
    RevokeIdentityProviderConnectionSecurity,
): string {
  return JSON.stringify(
    RevokeIdentityProviderConnectionSecurity$outboundSchema.parse(
      revokeIdentityProviderConnectionSecurity,
    ),
  );
}

/** @internal */
export type RevokeIdentityProviderConnectionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  RevokeIdentityProviderConnectionRequestBody:
    RevokeIdentityProviderConnectionRequestBody$Outbound;
};

/** @internal */
export const RevokeIdentityProviderConnectionRequest$outboundSchema:
  z.ZodMiniType<
    RevokeIdentityProviderConnectionRequest$Outbound,
    RevokeIdentityProviderConnectionRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      revokeIdentityProviderConnectionRequestBody:
        RevokeIdentityProviderConnectionRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        revokeIdentityProviderConnectionRequestBody:
          "RevokeIdentityProviderConnectionRequestBody",
      });
    }),
  );

export function revokeIdentityProviderConnectionRequestToJSON(
  revokeIdentityProviderConnectionRequest:
    RevokeIdentityProviderConnectionRequest,
): string {
  return JSON.stringify(
    RevokeIdentityProviderConnectionRequest$outboundSchema.parse(
      revokeIdentityProviderConnectionRequest,
    ),
  );
}
